/* eslint-disable jsx-a11y/anchor-is-valid */
import Navigation from 'components/Navigation';
import { AppStore } from 'contexts/AppStoreContext';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Project } from 'records/Project';
import { getFile } from 'services/fileService';
import { downloadFileWithAnchor, getDateString } from 'utils/general';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps, RouteComponentProps {}

class DownloadPage extends React.Component<Props, unknown, AppStore> {
  constructor(props: Props) {
    super(props);
  }

  handleDownload = async (): Promise<void> => {
    const queryParams = new URLSearchParams(this.props.location.search);

    const downloadQueryParam = queryParams.get('fileid');

    const { selectedProject, projects } = this.props.appState;
    const { name } = projects.get(selectedProject, new Project());

    if (downloadQueryParam) {
      const resp = await getFile(selectedProject, downloadQueryParam);
      const filename = `${name} - Data Export - ${getDateString()}.zip`;

      await downloadFileWithAnchor(resp.url, filename);
    }
  };

  render(): React.ReactNode {
    return (
      <Navigation>
        <div className="column items-center" style={{}}>
          <div style={{ height: '100px' }} />
          <div className="column center">
            <button className="btn btn-primary" onClick={this.handleDownload}>
              Download File
            </button>
          </div>
        </div>
      </Navigation>
    );
  }
}

export default withAppStore<Props>(DownloadPage);
